angular.module('jv.search.filter-transforms.service', [])
.factory('filterTransforms', ['jvSearchAjaxFilterTransform',
    function(jvSearchAjaxFilterTransform) {
        return function (availableFilters, selectedFilters, externalSelectedFilters) {
            var selectedFilters = angular.copy(selectedFilters);
            var externalSelectedFilters = angular.copy(externalSelectedFilters);
            var customFilters = [];
            var result = {};
            availableFilters.forEach(function(filter) {
                var type;
                var customFilter;
                if (selectedFilters[filter.searchId] != null) {
                    type = filter.filterType.toLowerCase();
                    if (filter.custom) {
                        // send custom filters separately
                        customFilter = {
                            fieldId: filter.searchId,
                            fieldType: filter.filterType,
                        };
                        if ((type === 'numberrange' || type === 'currency') && selectedFilters[filter.searchId].min != null && selectedFilters[filter.searchId].max != null && selectedFilters[filter.searchId].currency != '') {
                            customFilter.minValue = selectedFilters[filter.searchId].min;
                            customFilter.maxValue = selectedFilters[filter.searchId].max;
                            if(type === 'currency' && selectedFilters[filter.searchId].currency){
                                customFilter.unitOfMeasure = selectedFilters[filter.searchId].currency.currencyCode;
                            }
                        }
                        if (type === 'daterange' && selectedFilters[filter.searchId].from && selectedFilters[filter.searchId].to) {
                            customFilter.minValue = selectedFilters[filter.searchId].from;
                            customFilter.maxValue = selectedFilters[filter.searchId].to;
                        }
                        if (type === 'checkbox') {
                            // transform {key:bool value} to array
                            customFilter.values = Object.keys(selectedFilters[filter.searchId]).filter(function(key) {
                                return selectedFilters[filter.searchId][key];
                            }).map(function(value) {
                                // remove prefix added to avoid user provided strings as keys
                                return value.replace(/^jv\|\|/, '');
                            });
                        }
                        if (type === 'employee') {
                            customFilter.values = selectedFilters[filter.searchId].map(function(employee) {
                                return employee.EId;
                            });
                        }
                        if (type === 'text') {
                            customFilter.values = [selectedFilters[filter.searchId]];
                        }
                        if (type === 'dropdown') {
                            if (filter.multiple) {
                                filter = jvSearchAjaxFilterTransform.transform(filter);
                                customFilter.values = selectedFilters[filter.searchId].map(function(value) {
                                    return value[filter.key];
                                });
                            }
                            else {
                                customFilter.values = [selectedFilters[filter.searchId]];
                            }
                        }
                        if ((customFilter.values && customFilter.values.length) || (customFilter.minValue != null && customFilter.maxValue != null)) {
                            customFilters.push(customFilter);
                        }
                        delete selectedFilters[filter.searchId];
                    }
                    else {
                        // BE expects arrays of values for dropdown types.
                        // Filter directive can only make them arrays if multiselect is allowed
                        // so we're transforming before sending it off
                        if (type === 'dropdown' && !filter.multiple) {
                            selectedFilters[filter.searchId] = [selectedFilters[filter.searchId]];
                        }
                        if (type === 'dropdown' && filter.multiple) {
                            filter = jvSearchAjaxFilterTransform.transform(filter);
                            //Used to identify between filters that are of type "dropdown and multiple". There are ones which fetch
                            //data via ajax call. For them, filter.values will not be set and we need to transform for them, but for
                            //other filters like workflowstate and postingType, we do not need to do that transform of the values stored
                            //in the array.
                            if (!filter.values) {
                                selectedFilters[filter.searchId] = selectedFilters[filter.searchId].map(function(value) {
                                    return value[filter.key];
                                });
                            }
                        }
                        // BE expects jobid for specific requisition
                        if (type === 'requisition' && selectedFilters[filter.searchId].reqEId) {
                            selectedFilters.jobId = [selectedFilters[filter.searchId].reqEId];
                            delete selectedFilters[filter.searchId];
                        }
                        // BE expects array of collection ids
                        if (type === 'collection' && selectedFilters[filter.searchId].EId) {
                            selectedFilters.collectionId = [selectedFilters[filter.searchId].EId];
                            delete selectedFilters[filter.searchId];
                        }
                        // don't send location filter if no location is set
                        if (type === 'location' && !selectedFilters[filter.searchId].latitude) {
                            delete selectedFilters[filter.searchId];
                        }
                        // don't send date if missing to and from
                        if (type === 'daterange' && (!selectedFilters[filter.searchId].to || !selectedFilters[filter.searchId].from)) {
                            delete selectedFilters[filter.searchId];
                        }
                        if (type === 'company'){
                            if (selectedFilters[filter.searchId].companyNames && selectedFilters[filter.searchId].companyNames.length){
                                var companies = selectedFilters[filter.searchId].companyNames;
                                var companyNames = [];
                                angular.forEach(companies,function(companyObj,key){
                                    companyNames.push(companyObj.value);
                                });
                                //else if current send current as true
                                if(selectedFilters[filter.searchId].companyRange === 'current'){
                                    selectedFilters[filter.searchId].current = true;
                                    delete selectedFilters[filter.searchId].past;
                                }else if(selectedFilters[filter.searchId].companyRange === 'past'){
                                    // if past send past as true
                                    selectedFilters[filter.searchId].past = true;
                                    delete selectedFilters[filter.searchId].current;
                                }else{
                                    //if user select current or past be expects both current and past to be sent as true
                                    selectedFilters[filter.searchId].current = true;
                                    selectedFilters[filter.searchId].past = true;
                                }
                                selectedFilters[filter.searchId]['companyNames'] = companyNames;
                                delete selectedFilters[filter.searchId].companyRange;
                            } else {
                                delete selectedFilters[filter.searchId];
                            }
                        }
                        if (type === 'jobtitle') {
                            if (selectedFilters[filter.searchId].jobTitles && selectedFilters[filter.searchId].jobTitles.length){
                                var jobTitles = selectedFilters[filter.searchId].jobTitles;
                                var jobTitleArray = [];
                                angular.forEach(jobTitles,function(jobTitle,key){
                                    jobTitleArray.push(jobTitle.value);
                                });
                                selectedFilters[filter.searchId] = jobTitleArray;
                            } else {
                                delete selectedFilters[filter.searchId];
                            }
                        }
                        if (type === 'school'){
                            if (selectedFilters[filter.searchId].schools && selectedFilters[filter.searchId].schools.length){
                                var schools = selectedFilters[filter.searchId].schools;
                                var schoolsArray = [];
                                angular.forEach(schools,function(school,key){
                                    schoolsArray.push(school.value);
                                });
                                selectedFilters[filter.searchId] = schoolsArray;
                            } else {
                                delete selectedFilters[filter.searchId];
                            }
                        }
                        if (type === 'source') {
                            // split subtype into separate filter
                            if (selectedFilters[filter.searchId].subtype) {
                                selectedFilters.sourceDetail = [selectedFilters[filter.searchId].subtype];
                            }
                            // handle employee type
                            if (selectedFilters[filter.searchId].person) {
                                selectedFilters.sourceDetail = [selectedFilters[filter.searchId].person.EId];
                            }
                            // extract type into array
                            if (selectedFilters[filter.searchId].type) {
                                selectedFilters[filter.searchId] = [selectedFilters[filter.searchId].type];
                            }
                            if (selectedFilters[filter.searchId].ids) {
                                if (selectedFilters[filter.searchId].ids.length > 1) {
                                    delete selectedFilters.sourceDetail;
                                }
                                selectedFilters[filter.searchId] = selectedFilters[filter.searchId].ids;
                            }
                            else {
                                delete selectedFilters[filter.searchId];
                            }
                        }
                    }
                }
            });
            result = angular.extend({}, selectedFilters, externalSelectedFilters);
            result.customFilters = customFilters;
            return result;
        };
    }
])
.service('jvSearchAjaxFilterTransform', [
    function() {
        this.transform = function(filter) {
            if (filter.custom) {
                filter.url = [jvUrls.jhire, 'action/application/field', filter.searchId, 'values'].join('/');
                filter.key = 'key';
                filter.value = 'value';
                filter.resultList = 'resultList';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'q';
            } else if (filter.searchId === 'department') {
                filter.url = [jvUrls.admin, 'action/company/departments'].join('/');
                filter.key = 'EId';
                filter.value = 'name';
                filter.resultList = 'departments';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'name';
            } else if (filter.searchId === 'category') {
                filter.url = [jvUrls.admin, 'action/company/categories'].join('/');
                filter.key = 'EId';
                filter.value = 'name';
                filter.resultList = 'categories';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'name';
            } else if (filter.searchId === 'region') {
                filter.url = [jvUrls.admin, 'action/company/regions'].join('/');
                filter.key = 'EId';
                filter.value = 'name';
                filter.resultList = 'regions';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'name';
            } else if (filter.searchId === 'companies') {
                filter.url = [jvUrls.admin, 'action/company/subsidiaries'].join('/');
                filter.key = 'EId';
                filter.value = 'name';
                filter.resultList = 'subsidiaries';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'name';
            } else if (filter.searchId === 'recruiters') {
                filter.url = [jvUrls.admin, 'action/user/search?&fieldId=-16&applyHMMRestriction=true&pageSize=50&fetchMaxSize=true'].join('/');
                filter.key = 'EId';
                filter.value = 'fullName';
                filter.resultList = 'employees';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'q';
            } else if (filter.searchId === 'hiringManagers') {
                filter.url = [jvUrls.admin, 'action/user/search?&fieldId=-17&applyHMMRestriction=true&pageSize=50&fetchMaxSize=true'].join('/');
                filter.key = 'EId';
                filter.value = 'fullName';
                filter.resultList = 'employees';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'q';
            } else if (filter.searchId === 'jobLocation') {
                filter.url = [jvUrls.admin, 'action/company/locations'].join('/');
                filter.key = 'EId';
                filter.value = 'name';
                filter.resultList = 'locations';
                filter.directive = 'jv-ajax-dropdown-filter';
                filter.queryParamName = 'name';
            }
            return filter;
        };
    }
]);
